import { Injectable } from '@angular/core';
import { TypedAction } from '@ngrx/store/src/models';
import { LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { AuthenticationActionTypes } from '../+state';
import { TokenResult } from '../models';
import { BaseHandler } from './base.handler';

@Injectable()
export class HandlerChainService {
  private handlers: BaseHandler[] = [];

  public addHandler(handler: BaseHandler): HandlerChainService {
    if (this.handlers.length) {
      this.handlers[this.handlers.length - 1].addNext(handler);
    }
    this.handlers.push(handler);
    return this;
  }

  public handle(response: LoyaltyResponse<TokenResult>): TypedAction<AuthenticationActionTypes> {
    if (this.handlers.length) {
      const result = this.handlers[0].handle(response);
      this.handlers = new Array<BaseHandler>();
      return result;
    }
    return null;
  }
}
